Ext.define('SA.controller.ListCmpRenderer', {
    statics: {
        create({listCmp, itemXtype, updateItemCmp, getItemModels, getItemModelId, onCreate = null}) {
            var itemCmpMap = new Map(),
                delegate = {updateItemCmp, getItemModels, getItemModelId, onCreate};

            return new SA.controller.ListCmpRenderer({listCmp, itemXtype, itemCmpMap, delegate});
        }
    },

    constructor({listCmp, itemXtype, itemCmpMap, delegate}) {
        this.listCmp = listCmp;
        this.itemXtype = itemXtype;
        this.itemCmpMap = itemCmpMap;
        this.delegate = delegate;
    },

    getItemModelIds() {
        return Array.from(this.itemCmpMap.keys());
    },

    renderState(state) {
        var entries = this.delegate
            .getItemModels(state)
            .map(itemModel => {
                var itemModelId = this.delegate.getItemModelId(itemModel),
                    itemCmp = this.itemCmpMap.get(itemModelId);

                if (!itemCmp) {
                    itemCmp = Ext.widget({xtype: this.itemXtype});

                    this.itemCmpMap.set(itemModelId, itemCmp);

                    itemCmp.on('destroy', () => this.itemCmpMap.delete(itemModelId));

                    this.delegate.onCreate?.({itemModelId, itemCmp});
                }

                return {state, itemModelId, itemModel, itemCmp};
            });

        this.listCmp.syncItems(entries.map(({itemCmp}) => itemCmp));

        entries.forEach(entry => this.delegate.updateItemCmp(entry));
    }
});